
import UiLazyVideo from "~/components/UI/UiLazyVideo.vue";
import CloseSvgBold from "~/components/svg/CloseSvgBold.vue";

export default {
  name: "ImageViewer",
  components: { CloseSvgBold, UiLazyVideo },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    file: {
      type: Object,
      default: null,
    },
  },
  watch: {
    value: {
      handler(val) {
        if (!process.client) return;
        if (val) {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflow = "";
        }
      },
      immediate: true,
    },
  },
  mounted() {
    document.addEventListener("keyup", this.onKeyUp);
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.onKeyUp);
  },
  methods: {
    closeModal() {
      this.$emit("input", false);
    },
    onKeyUp(evt) {
      if (evt.keyCode === 27) {
        this.closeModal();
      }
    },
    isVideo(item) {
      return item?.media_type?.includes("video");
    },
  },
};
